import { Link } from 'react-router-dom';
import { Phone, MessageCircle, Mail } from 'lucide-react';
import { BUSINESS, NAV_LINKS } from '@/lib/constants';

export default function Footer() {
  return (
    <footer className="bg-secondary border-t" data-testid="site-footer">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 py-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground font-display font-bold">IR</span>
            <span className="font-display font-semibold">{BUSINESS.name}</span>
          </div>
          <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
            Local Staten Island cab service for everyday rides, airport trips, and out-of-town travel. Pre-installed child seats upon request.
          </p>
        </div>

        <div>
          <h4 className="font-display font-semibold text-sm uppercase tracking-wide">Services</h4>
          <ul className="mt-3 space-y-2 text-sm">
            {NAV_LINKS.slice(0, 3).map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-foreground/80 hover:text-primary" data-testid={`footer-link-${l.to.replace('/', '')}`}>{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-sm uppercase tracking-wide">Company</h4>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/contact" className="text-foreground/80 hover:text-primary" data-testid="footer-link-contact">Contact</Link></li>
            <li><Link to="/request-a-ride" className="text-foreground/80 hover:text-primary" data-testid="footer-link-request">Request a Ride</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-sm uppercase tracking-wide">Contact</h4>
          <ul className="mt-3 space-y-2 text-sm">
            <li>
              <a className="inline-flex items-center gap-2 text-foreground/80 hover:text-primary" href={BUSINESS.phoneTel} data-testid="footer-phone-link">
                <Phone className="h-4 w-4" /> {BUSINESS.phone}
              </a>
            </li>
            <li>
              <a className="inline-flex items-center gap-2 text-foreground/80 hover:text-primary" href={BUSINESS.whatsappUrl} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link">
                <MessageCircle className="h-4 w-4" /> WhatsApp
              </a>
            </li>
            <li>
              <a className="inline-flex items-center gap-2 text-foreground/80 hover:text-primary" href={BUSINESS.emailMailto} data-testid="footer-email-link">
                <Mail className="h-4 w-4" /> {BUSINESS.email}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t">
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
          <p>Serving Staten Island and beyond • Local rides · Airport trips · Out-of-town travel</p>
        </div>
      </div>
    </footer>
  );
}
